import { Component, OnInit, Input, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainSearch, ComplainAttachment, Glitch_UpdateRequest, GlitchAttachment } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, JobOperationActions, MasterConstants, ComplainType, Priorities, JobPopoverMode, AuthActionCodes, GlitchOperationActions, Modules } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import * as _ from 'lodash';
import * as moment from 'moment';
const momentDuration = require("moment-duration-format");
import { ComplainService } from '../../Services/ComplainService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EntityCodes } from '../../Models/EnumModels';
import { TagStaff } from '../TagStaff/TagStaff';
import { SendMsg } from '../SendMsg/SendMsg';
import { GlitchService } from '../../Services/GlitchService';

@Component({
    selector: 'GlitchPopover',
    templateUrl: './GlitchPopover.html'  
})

export class GlitchPopover extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild("tagStaff") tagStaff: TagStaff;
    @ViewChild('sendMsg') sendMsg: SendMsg;
    
    Model: any;
    DateFormat: string;
    cDate: Date = new Date();

    _GlitchOperationActions = GlitchOperationActions;
    _MasterConstants = MasterConstants;

    @Input() Mode: JobPopoverMode = JobPopoverMode.Default;
    @Input() increasePopupOpacity: boolean = false;
    _JobPopoverMode = JobPopoverMode;
    _Module = Modules;

    UpdateModel: Glitch_UpdateRequest;

    SelectedNav: number = 1;
    GSRAuditData: any;

    _EntityCodes = EntityCodes;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, public complainService: ComplainService, public glitchService: GlitchService) {
        super(translate, toastr, route, router, masterService);

        let m: any;
        m = momentDuration;
        m(moment);
    }

    ngOnDestroy(): void {
    }

    @Input() set Selected(data: any) {

        if (this.Model != null && data != null && this.Model.GlitchId == data.GlitchId)
            return;
        //console.log(data)
        this.Model = data;

        this.onOpen();

        this.SelectedNav = 1;
    }

    SetUpdateModel(): void {
        if (this.Model == null)
            return;

        this.UpdateModel = new Glitch_UpdateRequest();
        this.UpdateModel.Attachments = this.Model.Attachments;
        this.UpdateModel.GlitchId = this.Model.GlitchId;
        this.UpdateModel.PropertyId = this.Model.PropertyId;
    }
    

    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
        //this.SetData();
        //this.complainService.JobConsoleRefreshEvent.pipe(untilDestroyed(this)).subscribe((ComplainId) => {
        //    if (this.Model && ComplainId == this.Model.ComplainId) {
        //        this.GetGSRAudit();
        //        this.GetHistory();
        //    }
        //});

        //this.complainService.ComplainRowChanged.pipe(untilDestroyed(this)).subscribe((data) => {
        //    if (this.Model && data.ComplainId == this.Model.ComplainId) {
        //        this.GetGSRAudit();
        //        this.GetHistory();
        //    }
        //});
    }

    SetData(): void {
       // this.GetHistory();
       // this.GetGSRAudit();
        this.SetUpdateModel();
        this.GetGSRAudit();
    }

    onOpen(): void {
       this.SetData();
    }

    onOperation(Mode: GlitchOperationActions): void {
        this.SetUpdateModel();
        switch (Mode) {
            case GlitchOperationActions.Close:
                
                break;
            case GlitchOperationActions.AddInvestigation:
                
                break;
            case GlitchOperationActions.AddRecovery:
                
                break;
            case GlitchOperationActions.Edit:
                this.glitchService.OpenForEdit(this.Model);
                this.glitchService.SelectedGlitch = null;
                break;
            case GlitchOperationActions.Copy:
                this.glitchService.OpenForCopy(this.Model);
                this.glitchService.SelectedGlitch = null;
                break;
        }
    }

    onSelectedStaff(StaffId: number): void {

    }

    onClose(): void {
        this.Model = null;
        this.glitchService.SelectedGlitch = null;
    }

    ResetAttachmentCount(): void {
        if (this.Model.Attachments != null && this.Model.Attachments.length == 0) {
            this.Model.NoOfAttachments = 0;
        }
        else {
            this.Model.NoOfAttachments = this.Model.Attachments.length;
        }
    }

    onAttachmentChanged(data: GlitchAttachment[]): void {
        this.Model.Attachments = data;
        this.ResetAttachmentCount();
        this.glitchService.TriggerRequireFullRefresh();
    }

    onDeleteAttachment(row: GlitchAttachment): void {
        let deleteText = this.translate.instant('LBL.DELETE_CONFIRM');
        let confirmDelete = confirm(deleteText+"?");
        if (!confirmDelete)
            return;

        let req = _.cloneDeep(this.UpdateModel);
        req.Operation = GlitchOperationActions.EditAttachment;

        req.Attachments = [];

        row.IsDeleted = true;
        req.Attachments.push(row);

        this.glitchService.Glitch_Register(req).then(data => {
            this.FromBaseResponse(data);
            if (this.HasErrors)
                return;

            //row = data.Result;

            this.GetMultilingualToast('TS.TS_FILE_DELETED_SUCCESS', 'success');
            this.onAttachmentChanged(data.Result.Attachments);
        });
    }

    onTagStaff(): void {
        this.tagStaff.Open(this.Model.GlitchId, EntityCodes.Glitch, this.Model.PropertyId, this.Model);
    }
    onTagStaffChanged(data: Array<number>): void {
        this.glitchService.TriggerRequireFullRefresh();
    }
    GetGSRAudit(): void {
        if (this.Model == null)
            return;

        this.IsSubmitting = true;
        this.glitchService.Glitch_GetGSRAudit(this.Model.GlitchId).then(data => {
            if (data.GSRData) {
                this.GSRAuditData = data.GSRData;
                this.IsSubmitting = false;
                this.TransformGSRAudit();
            }
        }).catch(err => {
            this.IsSubmitting = false;
        });
    }

    TransformGSRAudit(): void {
        for (let i = 0; i < this.GSRAuditData.length; i++) {
            this.GSRAuditData[i].AuditorName = this.masterService.MasterData_GetMutli(this.Model.PropertyId, this.GSRAuditData[i].AuditorId, EntityCodes.Staff, "")
        }
    }
}
